import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'ax-putaway-on-container-page',
    templateUrl: './on-container-page.component.html',
    styleUrl: './on-container-page.component.scss',
})
export class OnContainerPageComponent {}
